import { Component, OnInit, ElementRef } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';

@Component({
  selector: 'app-front-meeting',
  templateUrl: './front-meeting.component.html',
  styleUrls: ['./front-meeting.component.css']
})
export class FrontMeetingComponent implements OnInit {

    roomevents:RoomEvents[];
    meetingrooms:MeetingRooms[];
    public room_id_from_url:string;

    public Event_name:string;
    public Event_start_time:string;
    public Event_end_time:string;
    public Event_start_date:string;
    public Event_end_date:string;
    public Event_Host_Name:string;
    public Event_Logo_Path:string;
    public Event_Attendants_Array:string[];

    public Event_room_name:string;

    constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {
    setInterval(() => {
      this.refreshData();
    }, 5000);
    }


  ngOnInit() {
    this.refreshData();
    $('.fullscreen_image').hide();


  }

   format_time= (date_obj) => {
  // formats a javascript Date object into a 12h AM/PM time string
  var hour = date_obj.getHours();
  var minute = date_obj.getMinutes();
  var amPM = (hour > 11) ? "PM" : "AM";
  if(hour > 12) {
    hour -= 12;
  } else if(hour == 0) {
    hour = "12";
  }
  if(minute < 10) {
    minute = "0" + minute;
  }
  return hour + ":" + minute +" "+ amPM;
}

// Accepts a Date object or date string that is recognized by the Date.parse() method
getDayOfWeek =(date) => {
var dayOfWeek = new Date(date).getDay();
return isNaN(dayOfWeek) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
}

    refreshData = ()=>{
      this.room_id_from_url = this.route.snapshot.paramMap.get('id');
      this.getdataService.getMeetingRoombyID(this.room_id_from_url).subscribe((meetingrooms) => {
        this.meetingrooms=  meetingrooms;
        this.Event_room_name=  this.meetingrooms[0].room_name;
      },
      err=>{
        //////console.log(err);
        return false;
      });


      this.getdataService.getEventByRoomID(this.room_id_from_url).subscribe((roomevents) => {
        this.roomevents=  roomevents;
        //////console.log(this.roomevents[0]);
        var d = new Date();
        //////console.log(d);
        var currentDate = d.getTime();
        this.Event_name = '';
      //  this.Event_room_name = '';


        
        for(var i=0; i<this.roomevents.length; i++)
        {
          var startDate = new Date(this.roomevents[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
          var endDate = new Date(this.roomevents[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);

          //////console.log("Event start time: "+ startDate);
          //////console.log("Event end time: "+ endDate);

          if(startDate<currentDate && endDate>currentDate)
          {
              $('.fullscreen_image').hide();
            /////event name/////
            this.Event_name = this.roomevents[i].event_name;

            ////Date////
            var date_now = new Date();
             var dd = date_now.getDate();

            var mm = date_now.getMonth() + 1; // 0 is January, so we must add 1
            var yyyy = date_now.getFullYear();
            var day = this.getDayOfWeek(date_now);
            // &nbsp;

            this.Event_start_date = day+" "+dd+"."+mm+"."+yyyy;
            //////console.log(this.Event_start_date );
            //////date////////
            var  date = new Date(startDate);

            this.Event_start_time = this.format_time(date).toString();
            //////console.log(this.format_time(date));
            date = new Date(endDate);
            this.Event_end_time = this.format_time(date).toString();
            //////console.log(this.format_time(date));

            ///////Host Name////////
            this.Event_Host_Name = this.roomevents[i].event_host_name;

            /////event attendants array ///
            this.Event_Attendants_Array = this.roomevents[i].event_attendants;

            //////image file path////////
            if(this.roomevents[i].event_logo_path == '')
            {
              //////console.log("there is no logos");
              this.Event_Logo_Path = this.meetingrooms[0].room_default_logo_path;
            }else{
              this.Event_Logo_Path = this.roomevents[i].event_logo_path;
            }
            break;
          }else{
            //////console.log("no event now");
            this.Event_name = 'currently no event' ;
              $('.fullscreen_image').show();
            this.Event_start_time = ' ';
            this.Event_end_time = ' ';
            this.Event_Host_Name = ' ';
            //////console.log(this.Event_Logo_Path);
            this.Event_Logo_Path = this.meetingrooms[0].room_default_logo_path;
          }

        }
        //////console.log('events in stackl: ' +this.roomevents.length);

        if(this.roomevents.length <1)
        {
          //////console.log("no event now");
          this.Event_name = 'currently no event' ;
            $('.fullscreen_image').show();
          this.Event_start_time = ' ';
          this.Event_end_time = ' ';
          this.Event_Host_Name = ' ';
          //////console.log(this.Event_Logo_Path);
          this.Event_Logo_Path = this.meetingrooms[0].room_default_logo_path;
        }
        // if(this.Event_name == '')
        // {
        //   this.Event_name = 'currently no event' ;
        // //  this.Event_room_name = 'room name';
        // }

      },
    err=>{
      //////console.log(err);
      return false;
    });





    }

}

interface MeetingRooms{
  _id:number,
  room_name:string,
  room_place:string,
  room_default_logo:string,
  room_default_logo_path:string,
  room_type:string,
  room_floor_number:string,
  room_slider_ID:string
}

interface RoomEvents{
  _id:number,
  event_name:string,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  event_host_name:string,
  event_attendants:string[]
}



// WEBPACK FOOTER //
// ./src/app/components/front-meeting/front-meeting.component.ts